<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <legend>Metrics</legend>
            <!--Grid row-->
            <b-row>
                <b-col>
                    <p>This Month Deposits {{totalMonthly}}</p>
                    <b-table striped hover bordered :items="itemsMonthly" :fields="fields">
                    </b-table>
                </b-col>
                <b-col>
                    <p>Today Deposits {{totalDaily}}</p>
                    <b-table striped hover bordered :items="itemsDaily" :fields="fields">

                    </b-table>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <p>This Month Payments {{totalPaymentMonthly}}</p>
                    <b-table striped hover bordered :items="itemsPaymentMonthly" :fields="fields">
                    </b-table>
                </b-col>
                <b-col>
                    <p>Today Payments {{totalPaymentDaily}}</p>
                    <b-table striped hover bordered :items="itemsPaymentDaily" :fields="fields">

                    </b-table>
                </b-col>
            </b-row>
            <!--spinner-->
            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
            <!--spinner-->
            <!--Grid row-->
        </div>
    </main>
    <!--Main layout-->
</div>